var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-pagination',{staticClass:"custom-pagination",attrs:{"current-page":_vm.currentPage,"page-sizes":_vm.pageSizes,"page-size":_vm.pageSize,"layout":_vm.isMobile ? _vm.mobileLayout : _vm.layout,"total":_vm.total,"pager-count":_vm.isMobile ? 5 : 7},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }